import React, { useEffect, useState } from "react";
import { Label } from "reactstrap";
import SignatureDrawing from "../../FinishSessionModal/SignatureDrawing/SignatureDrawing";

const EvaluationSubmission = ({
    account,
    session,
    answerFactor,
    setAnswerFactor,
    currentStep,
    currentSubPage,
    maxSubPage,
    setCurrentStep,
    setCurrentSubPage,
    setMaxSubPage,
    setStepInComplete,
    setSubPageInComplete,
    setValidationMessage
}) => {
    const usr = localStorage.getItem('name');
    const title = localStorage.getItem('title');

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        }); // e.g., April 1, 2025
    };

    // Notify parent that this step has only one subpage (index 0)
    useEffect(() => {
        setMaxSubPage(1);
    }, [setMaxSubPage]);

    const handleSignatureChange = (signature, type) => {
        setAnswerFactor(prev => ({
            ...prev,
            [type]: signature
        }));
    };

    useEffect(() => {
        if (currentSubPage === 0 && !answerFactor?.first_signature) {
            setValidationMessage('No signature found!')
            setSubPageInComplete(true);
        } else if (currentSubPage === 1 && !answerFactor?.second_signature) {
            setValidationMessage('No signature found!')
            setSubPageInComplete(true);
        } else {
            setSubPageInComplete(false);
        }
    }, [currentSubPage, answerFactor?.first_signature, answerFactor?.second_signature]);

    const signatureData = [
        {
            signature: answerFactor?.first_signature || null,
            onChange: (sig) => handleSignatureChange(sig, 'first_signature'),
            name: account?.Name,
            position: "Evaluatee"
        },
        {
            signature: answerFactor?.second_signature || null,
            onChange: (sig) => handleSignatureChange(sig, 'second_signature'),
            name: usr,
            position: "Evaluator"
        }
    ];

    const { signature, onChange, name, position } = signatureData[currentSubPage] ?? {};

    return (
        <div className='evaluation-submission d-flex flex-column h-100'>
            <div className="form-labels">
                <div className="label-row">
                    <div className="d-flex">
                        <Label className="label-title">AGENT NAME:</Label>
                        <Label>{account?.Name}</Label>
                    </div>
                    <div className="d-flex">
                        <Label className="label-title">DATE:</Label>
                        <Label>{formatDate(session?.SessionDate)?.toUpperCase()}</Label>
                    </div>
                </div>

                <div className="label-row">
                    <div className="d-flex">
                        <Label className="label-title text-nowrap">CLIENT NAME:</Label>
                        <Label>
                            {answerFactor?.clients
                                ? answerFactor.clients.map(c => c.name).join(', ')
                                : ''}
                        </Label>
                    </div>
                </div>
                <Label className="label-title mt-5">By affixing our signature, we acknowledge that we had discussed this evaluation and understood its contents.</Label>
            </div>

            <div className="flex-grow-1 d-flex flex-column mt-2">
                <div className={`evaluation-signature flex-grow-1 ${currentSubPage === 0 ? 'first-signature' : 'second-signature'}`}>
                    <SignatureDrawing key={currentSubPage} Signature={signature} onSignatureChange={onChange} />
                    <div className="details">
                        <div className="name">{name}</div>
                        <div className="position">{position}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EvaluationSubmission